// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Slide_arrow__4mKSM","container":"Slide_container__3bJsL","nextArrow":"Slide_nextArrow__LauZs","prevArrow":"Slide_prevArrow__286vV","track":"Slide_track__1uVOb"};